ACC.select = {
	_autoload: [
		"CustomSelect",
		"changeSelectQuantity",
		"checkBundleSelect"
	],

	CustomSelect: function () {
		$('.select-sort').each(function () {
			const $this = $(this);
			const numberOfOptions = $this.children('option').length;

			// Initialisation de la structure HTML
			$this.addClass('select-hidden').wrap('<div class="select"></div>');
			$this.after('<div class="select-styled"></div>');

			const $styledSelect = $this.next('.select-styled');
			const selectedOption = $this.find('option:selected');
			const selectedValue = selectedOption.val();
			const selectedText = selectedOption.text();

			// Configuration initiale du select
			$styledSelect.text(selectedText).attr('rel', selectedValue);

			// Création de la liste des options
			const $list = $('<ul />', { class: 'select-options' }).insertAfter($styledSelect);
			$this.children('option').each(function () {
				$('<li />', {
					text: $(this).text(),
					rel: $(this).val()
				}).appendTo($list);
			});

			// Initialisation de l'élément sélectionné
			$list.find(`li[rel="${selectedValue}"]`).addClass('selected');

			// Gestion des événements
			$styledSelect.on('click', function (e) {
				e.stopPropagation();
				$('.select-styled.active').not(this).removeClass('active').next('.select-options').hide();
				$(this).toggleClass('active').next('.select-options').toggle();
			});

			$list.on('click', 'li', function (e) {
				e.stopPropagation();
				const $selectedItem = $(this);
				$styledSelect.text($selectedItem.text()).attr('rel', $selectedItem.attr('rel')).removeClass('active');
				$list.children().removeClass('selected');
				$selectedItem.addClass('selected');
				$this.val($selectedItem.attr('rel')).trigger('change');
				$list.hide();
			});

			$(document).on('click', function () {
				$styledSelect.removeClass('active');
				$list.hide();
			});
		});

		// Mise à jour du texte de l'unité
		ACC.select.updateUnit();
	},

	checkBundleSelect: function () {
		const $selectPdp = $('.price-table .select-options li[rel="bundle"]');
		const $qtySelectorInput = $('.js-qty-selector-input');
		const maxBundle = $qtySelectorInput.data('max-bundle');
		const maxPiece = $qtySelectorInput.data('max-normal');
		const maxPieceLimit = $('.js-piece-stock-limit').data('stock-limit');
		const $confProductDetails = $('.ajax-confProduct-details.confProductDetails');
		const $variantFields = $('.variant-values:not(.configurations-values) fieldset');

		if ($(".page-productDetails").length && $qtySelectorInput.val()) {
			$qtySelectorInput.trigger('keyup');
		}

		if ($selectPdp.hasClass('selected')) {
			$(".piecePoidLabel").hide();
			$(".bundlePoidLabel").show();
			$('.js-qty-selector-input:visible').trigger('input');
			if(maxBundle > 0){
				$qtySelectorInput.attr({ "data-max": maxBundle, "data-maxor": maxBundle });
				$('.js-qty-dispo').text(maxBundle);
			}
			$('#isBundleEntry').val("true");

			$('.js-bundle').removeClass("hidden").find('.cellM').addClass("hidden");
			$('.js-pieces').addClass("hidden");
			$('.configurableSelect').addClass('disabled');

			$variantFields.each(function () {
				if ($(this).find('.checked input:checked').length) {
					$confProductDetails.find('.variants-block, .amds-checkbox.configurationCheckbox').addClass('disabled');
					$confProductDetails.find('#configureProductCheckbox').prop({ checked: false, disabled: true });
					$confProductDetails.find('#configureProductLabel').prop('disabled', true);
				}
			});
		} else {
			$('.js-qty-selector-input:visible').trigger('input');
			$(".bundlePoidLabel").hide();
			$(".piecePoidLabel").show();
			$qtySelectorInput.attr({ "data-max": maxPiece, "data-maxor": maxPiece, "data-max-order": maxPieceLimit });
			$('#isBundleEntry').val("false");
			$('.js-qty-dispo').text(maxPiece);
			$('.js-bundle, .js-bundle .cellM').addClass("hidden");
			$('.js-pieces').removeClass("hidden");

			const disableConfig = $('#variants-block').data('disable-check-box-configuration');
			if (!disableConfig && $variantFields.find('.checked input:checked').length) {
				$confProductDetails.find('.variants-block, .amds-checkbox.configurationCheckbox').removeClass('disabled');
				$confProductDetails.find('#configureProductCheckbox, #configureProductLabel').prop('disabled', false);
			}
			$('.dispo-stock.dispo-stock-normal').removeClass('hidden-stock');
		}
	},

	changeSelectQuantity: function () {
		$(document).on('change', '.js-quantity-choice', function () {
			$('.js-qty-selector-input').trigger('keyup');
			ACC.select.updateUnit();
			ACC.select.checkBundleSelect();
			ACC.track.contentsquareAPVTracking("product-unit-selector");
		});
	},

	updateUnit: function () {
		let selectedUnit = $('.select-options li.selected').text() || $('.js-product').text();
		$('.js-unit').text(selectedUnit);
	}
};
